import { createRootRoute, Outlet } from "@tanstack/react-router";
import { ClassPickerDialog } from "../components/class-picker-dialog.tsx";
import { CurrentLoadoutWidget } from "../components/current-loadout/current-loadout-widget.tsx";
import { OwnedDefaultsInitializer } from "../components/owned-items/owned-defaults-initializer.tsx";
import { PropagandaTicker } from "../components/propaganda-ticker.tsx";
import { SiteHeader } from "../components/site-header.tsx";

export const Route = createRootRoute({
	component: RootLayout,
});

function RootLayout() {
	return (
		<div className="min-h-screen bg-surface text-on-surface">
			<div className="fixed top-0 right-0 left-0 z-50">
				<SiteHeader />
				<PropagandaTicker />
			</div>
			<div className="pt-[96px] pb-[var(--current-loadout-h,56px)] md:pt-[88px] md:pb-[var(--current-loadout-h,52px)]">
				<Outlet />
			</div>
			<CurrentLoadoutWidget />
			<ClassPickerDialog />
			<OwnedDefaultsInitializer />
		</div>
	);
}
